import { Column } from 'react-table';
import { DateColumnFilter } from 'utils/react-table';
import DateTimeCell from 'pages/event-list-page/event-table-cells/date-time-cell';

const CityTableColumnConfig: Column[] = [
    {
        Header: 'FDCP ID',
        accessor: 'fdcpId',
        disableSortBy: false,
    },
    {
        Header: 'Name',
        accessor: 'name',
        disableSortBy: false,
    },
    {
        Header: 'Country',
        accessor: 'country',
        disableSortBy: false,
    },
    {
        Header: 'State',
        accessor: 'state',
        disableSortBy: false,
    },
    {
        Header: 'Time Zone',
        accessor: 'timeZone',
        disableSortBy: false,
    },
    {
        Header: 'Tournaments',
        id: 'tournamentName',
        accessor: 'tournamentNames',
        disableSortBy: true,
        Cell: ({ value }: { value: string }): JSX.Element => (
            <>
                {value
                    .split('\n')
                    .filter(Boolean)
                    .map((tournamentName) => (
                        <div key={tournamentName}>{tournamentName}</div>
                    ))}
            </>
        ),
    },
    {
        Header: 'Created',
        accessor: 'created',
        disableSortBy: false,
        Filter: DateColumnFilter,
        Cell: DateTimeCell,
    },
    {
        Header: 'Modified',
        accessor: 'modified',
        disableSortBy: false,
        Filter: DateColumnFilter,
        Cell: DateTimeCell,
    },
];

export default CityTableColumnConfig;

export const DefaultVisibleCityColumns = [
    'fdcpId',
    'name',
    'country',
    'state',
    'timeZone',
    'tournamentNames',
    'created',
    'modified',
];

export const SearchableCityTableColumnConfig = ['fdcpId', 'name', 'country', 'state', 'timeZone', 'tournamentName'];
